// Mobile-only floating pill showing the active drawing tool's live numbers
// (ruler distance, infra budget, plan mode count) without needing to pull
// the bottom sheet open. Sits just above the collapsed sheet handle; the
// sheet's higher z-index naturally covers it once expanded.
import { pathLengthKm, editorPathLengthKm } from '../utils/structures'
import Icon from './Icons'
import '../styles/ActiveToolStatus.css'

const ActiveToolStatus = ({
  rulerMode, rulerPath,
  constructionMode, constructionTool, infrastructurePath, editingInfra,
  planMode, coloredRegionsCount,
}) => {
  let icon = null
  let label = null

  if (rulerMode) {
    const km = pathLengthKm(rulerPath.map((p) => [p.lngLat.lng, p.lngLat.lat]))
    icon = 'crosshair'
    label = `${rulerPath.length} pt · ${km.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} km`
  } else if (constructionMode && constructionTool === 'infra' && infrastructurePath.length > 0) {
    const km = editorPathLengthKm(infrastructurePath)
    icon = 'building'
    label = `${infrastructurePath.length} pt · ${km.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} km`
    if (editingInfra) label += ` / ${Number(editingInfra.owned_km).toLocaleString('fr-FR')} km`
  } else if (planMode) {
    icon = 'palette'
    label = `${coloredRegionsCount || 0} région(s) coloriée(s)`
  }

  if (!label) return null

  return (
    <div className="active-tool-status">
      <Icon name={icon} size={14} />
      <span>{label}</span>
    </div>
  )
}

export default ActiveToolStatus
